import React, { FC } from 'react';
import css from '../Form/styles.module.scss';

const FormScroll: FC = () => <div className={css.background} />;

export default FormScroll;
